import React, { useState } from "react";
import SunkenPanel from "../components/SunkenPanel";

// Every "final" version is the same file renamed, all in the last three minutes before the deadline.
const ITEMS = [
  { name: "portfolio.html", deleted: "12/31/99 11:57 PM", kb: 14 },
  { name: "portfolio_v2.html", deleted: "12/31/99 11:57 PM", kb: 14 },
  { name: "portfolio_v2_final.html", deleted: "12/31/99 11:57 PM", kb: 14 },
  { name: "portfolio_FINAL.html", deleted: "12/31/99 11:58 PM", kb: 14 },
  { name: "portfolio_FINAL_v2.html", deleted: "12/31/99 11:58 PM", kb: 14 },
  { name: "portfolio_FINAL_FINAL.html", deleted: "12/31/99 11:58 PM", kb: 14 },
  { name: "portfolio_FINAL_for_real_this_time.html", deleted: "12/31/99 11:59 PM", kb: 14 },
  { name: "portfolio_PUBLISHED_FINAL_VERSION.html", deleted: "12/31/99 11:59 PM", kb: 14 },
  { name: "portfolio_PUBLISHED_FINAL_VERSION (1).html", deleted: "12/31/99 11:59 PM", kb: 14 },
];

const formatSize = (kb) => (kb < 1024 ? `${kb}KB` : `${(kb / 1024).toFixed(1)}MB`);

const TOTAL_KB = ITEMS.reduce((sum, item) => sum + item.kb, 0);

const COLUMNS = [
  { label: "Name", key: "name", width: "w-[58%]" },
  { label: "Date Deleted", key: "deleted", width: "w-[28%]" },
  { label: "Size", key: "size", width: "w-[14%]" },
];

const RecycleBin = () => {
  const [selected, setSelected] = useState(null);

  return (
    <div className="flex flex-col h-full desktop-font text-xl select-none">
      <div className="flex-1 min-h-0">
        <SunkenPanel>
          <div
            className="h-full overflow-auto"
            onPointerDown={(e) => setSelected(e.target.closest("[data-item]")?.dataset.item ?? null)}
          >
            <div className="flex sticky top-0">
              {COLUMNS.map(({ label, width }) => (
                <div
                  key={label}
                  className={`${width} px-2 truncate bg-[#c0c0c0] border-[0.12rem] border-t-white border-l-white border-b-[#828282] border-r-[#828282]`}
                >
                  {label}
                </div>
              ))}
            </div>
            {ITEMS.map((item) => {
              const isSelected = selected === item.name;
              return (
                <div
                  key={item.name}
                  className="flex items-center h-7 cursor-default"
                  data-item={item.name}
                >
                  {COLUMNS.map(({ key, width }) => (
                    <div key={key} className={`${width} px-2 flex items-center gap-1 min-w-0`}>
                      {key === "name" && (
                        <img
                          src="/desktop-icons/document-icon.png"
                          alt=""
                          className="h-4 w-4 shrink-0"
                          draggable={false}
                        />
                      )}
                      <span
                        className={`truncate mt-[0.2rem] ${
                          key === "name" && isSelected ? "bg-[#00007F] text-white px-[0.1rem]" : ""
                        }`}
                      >
                        {key === "size" ? formatSize(item.kb) : item[key]}
                      </span>
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        </SunkenPanel>
      </div>
      <div className="flex shrink-0 h-6 mt-[0.15rem] px-2 items-center border-[0.1rem] border-t-[#828282] border-l-[#828282] border-b-white border-r-white">
        {ITEMS.length} object(s)&nbsp;&nbsp;&nbsp;{formatSize(TOTAL_KB)}
      </div>
    </div>
  );
};

export default RecycleBin;
